<template>
  <footer class="footer">
    <div class="container">
      <div class="row mb-5">
        <div class="col-md">
          <div class="mb-4">
            <h2 class="footer-heading">Waiheke Adventure Centre</h2>
            <p>
              Come and experience a range of adventure and fun activities during
              all seasons of the year.
            </p>
            <ul
              class="footer-social list-unstyled float-md-left float-lft mt-5"
            >
              <li>
                <a
                  href="https://twitter.com/TourismWaiheke"
                  style="padding-left: 10px; padding-top: 8px"
                  target="_blank"
                >
                  <svg
                    fill="#FFFFFF"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                    width="32px"
                    height="32px"
                  >
                    <path
                      d="M 28 8.558594 C 27.117188 8.949219 26.167969 9.214844 25.171875 9.332031 C 26.1875 8.722656 26.96875 7.757813 27.335938 6.609375 C 26.386719 7.171875 25.332031 7.582031 24.210938 7.804688 C 23.3125 6.847656 22.03125 6.246094 20.617188 6.246094 C 17.898438 6.246094 15.691406 8.453125 15.691406 11.171875 C 15.691406 11.558594 15.734375 11.933594 15.820313 12.292969 C 11.726563 12.089844 8.097656 10.128906 5.671875 7.148438 C 5.246094 7.875 5.003906 8.722656 5.003906 9.625 C 5.003906 11.332031 5.871094 12.839844 7.195313 13.722656 C 6.386719 13.695313 5.628906 13.476563 4.964844 13.105469 C 4.964844 13.128906 4.964844 13.148438 4.964844 13.167969 C 4.964844 15.554688 6.660156 17.546875 8.914063 17.996094 C 8.5 18.109375 8.066406 18.171875 7.617188 18.171875 C 7.300781 18.171875 6.988281 18.140625 6.691406 18.082031 C 7.316406 20.039063 9.136719 21.460938 11.289063 21.503906 C 9.605469 22.824219 7.480469 23.609375 5.175781 23.609375 C 4.777344 23.609375 4.386719 23.585938 4 23.539063 C 6.179688 24.9375 8.765625 25.753906 11.546875 25.753906 C 20.605469 25.753906 25.558594 18.25 25.558594 11.742188 C 25.558594 11.53125 25.550781 11.316406 25.542969 11.105469 C 26.503906 10.410156 27.339844 9.542969 28 8.558594 Z"
                    />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/WaihekeAdventureCentre/"
                  style="padding-left: 7px; padding-top: 8px"
                  target="_blank"
                >
                  <svg
                    fill="#FFFFFF"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="34px"
                    height="34px"
                  >
                    <path
                      d="M17.525,9H14V7c0-1.032,0.084-1.682,1.563-1.682h1.868v-3.18C16.522,2.044,15.608,1.998,14.693,2 C11.98,2,10,3.657,10,6.699V9H7v4l3-0.001V22h4v-9.003l3.066-0.001L17.525,9z"
                    />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/explore/tags/kayakwaiheke/"
                  style="padding-left: 6px; padding-top: 6px"
                  target="_blank"
                >
                  <svg
                    fill="#FFFFFF"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                    width="38px"
                    height="38px"
                  >
                    <path
                      d="M 11.46875 5 C 7.917969 5 5 7.914063 5 11.46875 L 5 20.53125 C 5 24.082031 7.914063 27 11.46875 27 L 20.53125 27 C 24.082031 27 27 24.085938 27 20.53125 L 27 11.46875 C 27 7.917969 24.085938 5 20.53125 5 Z M 11.46875 7 L 20.53125 7 C 23.003906 7 25 8.996094 25 11.46875 L 25 20.53125 C 25 23.003906 23.003906 25 20.53125 25 L 11.46875 25 C 8.996094 25 7 23.003906 7 20.53125 L 7 11.46875 C 7 8.996094 8.996094 7 11.46875 7 Z M 21.90625 9.1875 C 21.402344 9.1875 21 9.589844 21 10.09375 C 21 10.597656 21.402344 11 21.90625 11 C 22.410156 11 22.8125 10.597656 22.8125 10.09375 C 22.8125 9.589844 22.410156 9.1875 21.90625 9.1875 Z M 16 10 C 12.699219 10 10 12.699219 10 16 C 10 19.300781 12.699219 22 16 22 C 19.300781 22 22 19.300781 22 16 C 22 12.699219 19.300781 10 16 10 Z M 16 12 C 18.222656 12 20 13.777344 20 16 C 20 18.222656 18.222656 20 16 20 C 13.777344 20 12 18.222656 12 16 C 12 13.777344 13.777344 12 16 12 Z"
                    />
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md">
          <div class="mb-4 ml-md-5">
            <h2 class="footer-heading">Information</h2>
            <ul class="list-unstyled">
              <li>
                <a href="#/about-us" class="py-2 d-block">About us</a>
              </li>
              <li>
                <a href="#/gallery" class="py-2 d-block">Gallery</a>
              </li>
              <li>
                <a
                  href="https://www.tourismwaiheke.co.nz/ferry-information"
                  class="py-2 d-block"
                  target="_blank"
                  >How to get here</a
                >
              </li>
              <li>
                <a
                  href="https://www.tourismwaiheke.co.nz/"
                  class="py-2 d-block"
                  target="_blank"
                  >Tourism Waiheke</a
                >
              </li>
              <li>
                <a href="tel:+6493725550" class="py-2 d-block">Call us</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md">
          <div class="mb-4">
            <h2 class="footer-heading">Experience</h2>
            <ul class="list-unstyled">
              <li>
                <router-link class="py-2 d-block" to="/water-activities"
                  >Water Activities</router-link
                >
              </li>
              <li>
                <router-link class="py-2 d-block" to="/land-activities"
                  >Land Activities</router-link
                >
              </li>
              <li>
                <router-link class="py-2 d-block" to="/team-building"
                  >Team Building</router-link
                >
              </li>
              <li>
                <a
                  href="https://www.kayakwaiheke.co.nz/"
                  class="py-2 d-block"
                  target="_blank"
                  >Kayak Waiheke</a
                >
              </li>
              <li>
                <a
                  href="https://www.facebook.com/WaihekeAdventureCentre/reviews/"
                  class="py-2 d-block"
                  target="_blank"
                  >Facebook Reviews</a
                >
              </li>
              <li>
                <a
                  href="https://www.tripadvisor.co.nz/Attraction_Review-g285729-d6034278-Reviews-Kayak_Waiheke-Waiheke_Island_North_Island.html#REVIEWS"
                  class="py-2 d-block"
                  target="_blank"
                  >Tripadvisor Reviews</a
                >
              </li>
              <li>
                <a
                  href="https://g.page/r/CeM_L4hDLnzqEAU/review"
                  class="py-2 d-block"
                  target="_blank"
                  >Google Reviews</a
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md">
          <div class="mb-4">
            <h2 class="footer-heading">Have any Questions?</h2>
            <div class="footer-questions mb-3">
              <ul>
                <li>
                  <span
                    >Matiatia Beachfront <br />Waiheke island <br />New
                    Zealand</span
                  >
                </li>
                <li>
                  <a href="tel:+6493725550">
                    <span>+64 9 372 5550</span>
                  </a>
                </li>
                <li>
                  <router-link
                    class="py-2 d-block"
                    to="/contact"
                    style="color: rgba(255, 255, 255, 0.5)"
                    >Email Us</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-center">
          <p>
            © {{ new Date().getFullYear() }} Waiheke Adventure Centre &amp;
            Kayak Waiheke
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<style lang="scss">
.footer {
  //background-image: url('../assets/images/footer-bg.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: bottom center;
  padding: 7em 0;
  z-index: 0;
  line-height: 1.8;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
  background-color: #232228;

  ul li a {
    color: rgba(255, 255, 255, 0.5);
  }
}

.footer-heading {
  color: #fff;
  margin-bottom: 40px;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.5;
}

.footer-social li {
  list-style: none;
  margin: 0 10px 0 0;
  display: inline-block;
}

.footer-social li a {
  height: 50px;
  width: 50px;
  display: block;
  float: left;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 50%;
  position: relative;
}

.footer-questions {
  ul {
    padding: 0;
  }

  ul li {
    display: table;
    line-height: 1.5;
    margin-bottom: 15px;
  }

  ul li a {
    color: #ffffff;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}
</style>

<script>
export default {
  name: "Footer",
};
</script>
